module.exports = __webpack_public_path__ + "img/1080_14.56dad179.jpg";